import React from 'react'

import AlertDescriptionForm from 'pages/shared/AlertDescriptionForm'

import { useStoreContext } from 'hooks/StoreContext'
import useAlertDescriptions from 'hooks/useAlertDescriptions'

import { LoadingSinglePanePage, SinglePanePage } from 'styles/shared'

const AddAlertDescription = () => {
  useAlertDescriptions()

  const { areAlertDescriptionsLoaded } = useStoreContext()

  if (!areAlertDescriptionsLoaded) {
    return <LoadingSinglePanePage />
  }

  return (
    <SinglePanePage>
      <AlertDescriptionForm
        title="Add Alert"
        saveMethod="create"
      />
    </SinglePanePage>
  )
}

export default AddAlertDescription
